import React from 'react'

export const OscInfo = ({text,title}:Props) => {
    return (
        <div className='flex gap-x-2 m-1 '>
            <div className='font-semibold'> {title} </div>
            <div className='break-all' > {text} </div>
        </div>
    )
}

interface Props {
    text?: string | number,
    title: string
}
